 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPY from '@/components/xhtml/copy'
 import XHTMLDEDIC from '@/components/xhtml/dedic'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLFOREWORD from '@/components/xhtml/foreword'
 import XHTMLPREFACE from '@/components/xhtml/preface'
 import XHTMLINTRO from '@/components/xhtml/intro'
 import XHTMLCORE from '@/components/xhtml/core'
 import XHTMLPART1 from '@/components/xhtml/part1'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLCH05 from '@/components/xhtml/ch05'
 import XHTMLPART2 from '@/components/xhtml/part2'
 import XHTMLCH06 from '@/components/xhtml/ch06'
 import XHTMLCH07 from '@/components/xhtml/ch07'
 import XHTMLCH08 from '@/components/xhtml/ch08'
 import XHTMLCH09 from '@/components/xhtml/ch09'
 import XHTMLPART3 from '@/components/xhtml/part3'
 import XHTMLCH10 from '@/components/xhtml/ch10'
 import XHTMLCH11 from '@/components/xhtml/ch11'
 import XHTMLCH12 from '@/components/xhtml/ch12'
 import XHTMLCONCLUSION from '@/components/xhtml/conclusion'
 import XHTMLAPPA from '@/components/xhtml/appa'
 import XHTMLAPPB from '@/components/xhtml/appb'
 import XHTMLAPPC from '@/components/xhtml/appc'
 import XHTMLNOTES from '@/components/xhtml/notes'
 import XHTMLGLOSS from '@/components/xhtml/gloss'
 import XHTMLBIB from '@/components/xhtml/bib'
 import XHTMLACK from '@/components/xhtml/ack'
 import XHTMLINDEX from '@/components/xhtml/index'
 import XHTMLABOUT from '@/components/xhtml/about'
 import XHTMLABOUT1 from '@/components/xhtml/about1'
 import XHTMLBM01 from '@/components/xhtml/bm01'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/foreword",
 			"name" : "xhtml/foreword",
 			"component" : XHTMLFOREWORD
 		},
 		{
 			"path" : "/xhtml/preface",
 			"name" : "xhtml/preface",
 			"component" : XHTMLPREFACE
 		},
 		{
 			"path" : "/xhtml/intro",
 			"name" : "xhtml/intro",
 			"component" : XHTMLINTRO
 		},
 		{
 			"path" : "/xhtml/core",
 			"name" : "xhtml/core",
 			"component" : XHTMLCORE
 		},
 		{
 			"path" : "/xhtml/part1",
 			"name" : "xhtml/part1",
 			"component" : XHTMLPART1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js